function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPulsingPoints = function SvgPulsingPoints(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 800,
    height: 800,
    viewBox: "0 0 503.559 503.559"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M502.659 193.299c-2.4-8-9.6-14.4-18.4-16l-146.4-21.6-65.6-132c-4-8-12-12.8-20.8-12.8s-16.8 4.8-20.8 12.8l-65.6 132.8-145.6 20.8c-8.8 1.6-16 7.2-18.4 16-2.4 8-.8 17.6 5.6 24l105.6 103.2-24.8 145.6c-1.6 8.8 2.4 17.6 8.8 22.4 7.2 4.8 16.8 5.6 24 1.6l131.2-68.8 130.4 68.8c3.2 1.6 7.2 2.4 10.4 2.4 4.8 0 9.6-1.6 13.6-4 7.2-4.8 10.4-13.6 8.8-22.4l-24.8-145.6 105.6-103.2c7.2-6.4 9.6-16 7.2-24",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m136.259 481.299 115.2-60 115.2 60-115.2-115.2zM502.659 193.299c-2.4-8-9.6-14.4-18.4-16l-146.4-21.6-65.6-132c-4-8-12-12.8-20.8-12.8s-16.8 4.8-20.8 12.8l-65.6 132.8-65.6 9.6 313.6 313.6c2.4-4 3.2-8.8 1.6-13.6l-24.8-145.6 105.6-103.2c7.2-6.4 9.6-16 7.2-24",
    style: {
      fill: "#858c8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.459 10.899c-8 .8-16 5.6-20 12.8l-65.6 132.8-146.4 20.8c-8.8 1.6-16 7.2-18.4 16-2.4 8-.8 17.6 5.6 24l105.6 103.2-24.8 145.6c-1.6 8.8 2.4 17.6 8.8 22.4 7.2 4.8 16.8 5.6 24.8 1.6l130.4-68z",
    style: {
      fill: "#ffb000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m231.459 23.699-65.6 132.8-64.8 9.6 150.4 149.6v-304.8c-8 .8-16 5.6-20 12.8M137.059 481.299l114.4-59.2v-54.4z",
    style: {
      fill: "#ff9d00"
    }
  }));
};
export default SvgPulsingPoints;